import { useCallback, useEffect, useRef, useState } from "react";
import CourseCardComponentB2c from "./CourseCardComponentB2c";
import FilterAndSearchSection from "./FilterAndSearchSection";
import _ from "lodash";
import useLogin from "../../custom-hooks/useLogin";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCategoryListNew, getProductCategories, getProductCategoriesData } from "../../redux/courses/actions";
import { SessionKeys, convertHoursToMins, convertTimeFormat, getFormatCourseListFromWoo } from "../../utils/AppUtils";
import CONFIG from "../../utils/config";
import CourseCardOneB2C from "./CourseCardOneB2C";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import EventSliderFilterSection from "../NewDesign/Event/EventSliderFilter";
import StripOffer from "../Course/StripOffer";

const CourseListingMainComponent = (props) => {
  const { isAllCourse, isMyCourse, isFilterShow, tabKey, isPopular } = props

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoggedIn, userData } = useLogin()
  const observer = useRef();


  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let providerId = "";
  let allPartners = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    providerId = paramsReq.provider_id;
    allPartners = paramsReq?.allPartners;
  }
  // const providerId = params.get("provider_id");
  const tab = params.get("tab");

  const [selectedPartner, setSelectedPartner] = useState(
    providerId ? "" : "all"
  );

  const authBroker = useSelector((state) => state.auth.authBroker);
  var productCategoriesDataCatRes = useSelector((state) => state.courses.productCategoriesData);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);

  const [courseCount, setCourseCount] = useState(0)
  const [pageNum, setPageNum] = useState(0)

  const [isLoading, setIsLoading] = useState(false)
  const [searchText, setSearchText] = useState("");
  const [courseList, setCourseList] = useState([]);
  const [sortBy, setSortBy] = useState(isAllCourse ? 3 : 1);
  const [searchedOrNot, setsearchedOrNot] = useState(false);
  const [filterBy, setFilterBy] = useState(0);
  const [popularFilter, setPopularFilter] = useState()
  const [sortOption,] = useState([
    { value: 1, label: 'Name (A to Z)' },
    { value: 2, label: 'Name (Z to A)' },
    { value: 3, label: 'New To Old' },
    { value: 4, label: 'Old To New' }
  ])
  const [filterOption, setFilterOption] = useState([
    { value: 1, label: 'All' },
    { value: 4, label: 'Free for you' },
    // { value: 3, label: 'Purchased Courses' },
  ])
  const [selectedIds, setSelectedIds] = useState([])

  const [pageSize, setPageSize] = useState(12)
  const [currentPage, setCurrentPage] = useState(0)
  const [newCardData, setNewCardData] = useState(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  const [isFetching, setIsFetching] = useState(false)
  const [hasNoMore, setHasNoMore] = useState(true)
  const [totalRecords, setTotalRecords] = useState(0)

  const [apiListing, setApiListing] = useState([])

  useEffect(() => {
    resetAll()

  }, [authBroker, isAllCourse, isMyCourse, isPopular])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    resetAll()
    apiCall(1)
  }, [sortBy, filterBy, searchedOrNot, selectedIds, selectedPartner])




  useEffect(() => {
    console.log("returnData")
    return (() => {
      // dispatch(getProductCategoriesClear())
      // dispatch(getProductCategoriesDataClear())
      console.log('return')
      resetAll()
      // setPageNum(0)
    })
  }, [])
  const resetAll = () => {
    // setIsLoading(true)
    setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA)
    setIsFetching(false)
    setHasNoMore(true)
    setTotalRecords(0)
    setCurrentPage(0)
    setApiListing([])

    setPageNum(1)
  }


  useEffect(() => {
    console.log("start3")
    apiCall(pageNum)
  }, [pageNum])

  const apiCall = (page) => {
    console.log("CallCourseListApi: ", isLoggedIn, authBroker, selectedIds)
    if (!isLoggedIn || !_.isEmpty(authBroker)) {
      getCategoriesData(page);
    }
  }

  const getCategoriesData = (pageNum) => {
    setIsLoading(true)
    console.log('pageNumInReqApiCall1: ', pageNum, currentPage)
    if (isPopular) {
      setFilterOption([
        { value: 0, label: 'Overall' },
        { value: 7, label: 'This Week' },
        { value: 30, label: 'This Month' },
      ])
    } else {
      setFilterOption([
        { value: 1, label: 'All' },
        { value: 4, label: 'Free for you' },
      ])
    }
    let currentPageTemp = currentPage;
    if (pageNum === 0 || pageNum === 1) {
      setCurrentPage(0)
      currentPageTemp = 0;
    }

    let reqObj = {
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      category_id: selectedIds,
      provider_id: providerId ? providerId : selectedPartner!="all" ?  selectedPartner : '',
      search: searchText,
      sort: sortBy,
      page_size: pageSize,
      page: (currentPageTemp + 1),
      popular_tab: isPopular,
      popular_days: isPopular ? filterBy : "",
      isAll: allPartners ? selectedPartner != "all" ? false : true : false
    }

    let moduleName = "getProductCategoriesData"
    if (isAllCourse) {
      reqObj.brokerage_id = authBroker?.payload?.user?.company_id ? authBroker.payload.user?.company_id : "";
      reqObj.filter = isPopular ? 1 : filterBy;
    } else if (isMyCourse) {
      moduleName = "getProductCategoriesDataMyCourse"
    }
    dispatch(getProductCategoriesData({
      module: moduleName,
      postData: reqObj
    }))
  }

  useEffect(() => {
    console.log('productCategoriesDataCatRes: ', productCategoriesDataCatRes)
    parseCategoryDatRes(productCategoriesDataCatRes)
  }, [productCategoriesDataCatRes])

  const parseCategoryDatRes = (productCategoriesDataCatRes) => {
    if (!_.isEmpty(productCategoriesDataCatRes)) {
      setIsLoading(false)
      if (productCategoriesDataCatRes.status === "success") {
        const categoryData = productCategoriesDataCatRes?.payload?.payload

        if (categoryData?.courseList?.length > 0) {
          console.log('Sorted', _.sortBy(categoryData?.courseList, 'updated_dt'))
          let coursesList = categoryData?.courseList;
          for (let course of coursesList) {

            // let coursesData = formatWooCourses(data)
            course.isLock = false;

            if (course.source === 'broker') {
              course.is_paid = true;
              if (course.durationUnit === "Hours") {
                course.duration = convertHoursToMins(course.duration);
              }
              if (course.durationUnit === "Seconds") {
                course.duration = convertTimeFormat(course.duration, true);
              }
              // course.duration = convertTimeFormat(_.toNumber(course.duration));
              course.durationUnit = "";
              course.isLock = false;
            } else {
              course = getFormatCourseListFromWoo(course, isPremiumUser)
            }

          }

          setTotalRecords(categoryData?.total_record);
          setCourseCount(categoryData?.total_record);
          setCurrentPage(categoryData.page)

          setCourseList(coursesList);
        } else {
          setCourseList([]);
          setCourseCount(0)
        }

      }
    }
  }



  const paginateCB = useCallback((node) => {

    if (isFetching) return

    if (observer.current) observer.current.disconnect()

    observer.current = new IntersectionObserver(entries => {
      console.log("pageNumhasNoMore ", isFetching,entries[0].isIntersecting)
      if (entries[0].isIntersecting && !hasNoMore) {
        setIsFetching(true)
        setHasNoMore(true)
        // console.log('End of file', totalRecords, lpListing.length, pageNum, isLoading, isFetching)
        setPageNum(pageNum => pageNum + 1)  //pageNum => pageNum + 1
        setNewCardData([...newCardData, ...CONFIG.INITIAL_PRODUCT_CARD_DATA])
      }
    })

    if (node) observer.current.observe(node)
    console.log(node)
  }, [hasNoMore])


  return (<>
    <div className="tab-content" id="nav-tabContent">
      <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
       {allPartners ? <EventSliderFilterSection selectedPartner={selectedPartner} setSelectedPartner={setSelectedPartner}/> : "" }

        <FilterAndSearchSection
          sectionType={isMyCourse ? "myarea" : "public"}
          entityType={"course"}
          searchText={searchText}
          setSearchText={setSearchText}
          setsearchedOrNot={setsearchedOrNot}
          searchedOrNot={searchedOrNot}
          setFilterBy={setFilterBy}
          filterBy={filterBy}
          filterOption={filterOption}
          setSortBy={setSortBy}
          sortBy={sortBy}
          sortOption={sortOption}
          setSelectedIds={setSelectedIds}
          isFilterShow={isFilterShow}
          isLoading={isLoading} 
          tabKey={tabKey}
          selectedPartner={selectedPartner}
          />

          <StripOffer isTerm={false} page={"course"}/>

        <div className="mgt-3">
          {isLoading &&
            <span className="count-text-head">

              <ShimmerScreen case="rect" width="10rem" height="1.5rem" /></span>
          }
          {!isLoading && courseCount > 0 && <span className="count-text-head">We found {courseCount} course{courseCount > 1 ? "s" : ""} for you</span>}

          <div id="idCourseList" className="course-listing-box">

            <CourseCardOneB2C
              arrList={courseList}
              newCardData={newCardData}
              setNewCardData={setNewCardData}
              setHasNoMore={setHasNoMore}
              total_records={totalRecords}
              paginateCB={paginateCB}
              setIsFetching={setIsFetching}
              pageNum={pageNum}
              setCourseCount={setCourseCount}
              setCurrentPage={setCurrentPage}
              apiListing={apiListing}
              setApiListing={setApiListing}
            />
          </div>
        </div>

      </div >
      <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">...</div>
    </div >
  </>)

}
export default CourseListingMainComponent;